ñ<template>
    <div>
        <v-card>
            <v-card-title>
                <div class="headline">Mensajes</div>
            </v-card-title>
            <v-card-text>

                <v-list v-if="!loading">
                    <template v-for="(item, index) in mensajes">
                        <v-list-tile @click="showMessage(item)">
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.mensaje }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
                <v-progress-linear :indeterminate="true" v-else="loading"></v-progress-linear>
                <v-alert :value="noHayMensajes" outline color="error" icon="warning">
                    {{mensajeError}}
                </v-alert>
            </v-card-text>
        </v-card>
        <v-dialog v-model="showDialog" max-width="400">
            <v-card>
                <v-card-title class="headline">Mensaje:</v-card-title>
                <v-card-text v-html="previewText"></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click.native="closeDialog">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  import axios from 'axios'
  let marked = require('marked')

  export default {
    name: 'Mensajes',
    created () {
      this.getMensajes()
    },
    data: () => ({
      mensajes: [],
      mensaje: {mensaje: ''},
      showDialog: false,
      loading: false,
      noHayMensajes: false,
      mensajeError: ''
    }),
    computed: {
      previewText () {
        marked.setOptions({
          renderer: new marked.Renderer(),
          sanitize: true
        })
        return marked(this.mensaje.mensaje)
      }
    },
    methods: {
      getMensajes () {
        this.loading = true
        axios.get('alumno/mensajes')
          .then(resp => {
            this.mensajes = resp.data.mensajes
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            this.noHayMensajes = true
            this.mensajeError = 'No existen mensajes nuevos.'
          })
      },
      showMessage (item) {
        this.showDialog = true
        this.mensaje = item
      },
      closeDialog () {
        this.mensaje = {mensaje: ''}
        this.showDialog = false
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Mensajes.vue